var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha, lighten } from '../Helpers/ColorUtils';
/* By default, buttons do not inherit the font from the parent */
var COMMON_BUTTON_SX = {
    // TODO: Update this when the typography updated
    fontFamily: 'Open Sans',
    borderRadius: 2,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    borderWidth: 0,
    borderStyle: 'none',
    outlineOffset: 4,
    outlineColor: 'divider-dark',
    fontWeight: 5,
    '&:focus': {
        outlineStyle: 'solid',
        outlineWidth: 1,
    },
};
export var buttonSx = {
    borderWidth: 0,
    borderStyle: 'none',
};
export var classButtonSx = __assign(__assign({}, COMMON_BUTTON_SX), { paddingLeft: 5, paddingRight: 5, paddingTop: 2, paddingBottom: 2, '&:hover': {
        cursor: 'pointer',
    }, '&:disabled': {
        backgroundColor: 'gray-10',
        color: 'white',
    }, '&:disabled:hover': {
        backgroundColor: 'gray-10',
        color: 'white',
        cursor: 'not-allowed',
    } });
export var normalButtonSx = {
    fontWeight: 5,
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 5,
    paddingRight: 5,
    fontSize: 1,
    '@media screen and (min-width: 30em)': {
        paddingTop: 3,
        paddingBottom: 3,
    },
};
export var baseButtonSx = __assign(__assign({}, COMMON_BUTTON_SX), { '&:hover': {
        cursor: 'pointer',
    }, '&:disabled': {
        backgroundColor: 'gray-40',
        color: 'white',
    }, '&:disabled:hover': {
        backgroundColor: 'gray-40',
        color: 'white',
        cursor: 'not-allowed',
    } });
export var getSolidButtonSx = function (color) {
    return __assign(__assign({}, COMMON_BUTTON_SX), { color: 'white', bg: color, '&:hover': {
            color: color,
            bg: lighten(color, 0.4),
            cursor: 'pointer',
        }, '&:active': {
            color: 'white',
            bg: 'primary-80',
            cursor: 'pointer',
        }, '&:disabled': {
            backgroundColor: 'gray-40',
            color: 'white',
        }, '&:disabled:hover': {
            backgroundColor: 'gray-40',
            color: 'white',
            cursor: 'not-allowed',
        } });
};
export var getOutlinedButtonSx = function (color) {
    return __assign(__assign({}, COMMON_BUTTON_SX), { color: color, bg: 'transparent', borderStyle: 'solid', borderWidth: '1px', paddingTop: 'calc(1rem - 1px)', paddingBottom: 'calc(1rem - 1px)', borderColor: alpha(color, 0.5), '&:hover': {
            color: color,
            bg: lighten(color, 0.4),
            borderColor: color,
            cursor: 'pointer',
        }, '&:active': {
            color: 'primary-80',
            bg: 'transparent',
            borderColor: 'primary-80',
            cursor: 'pointer',
        }, '&:disabled': {
            backgroundColor: 'transparent',
            color: 'gray-40',
            borderColor: 'gray-40',
        }, '&:disabled:hover': {
            backgroundColor: 'transparent',
            color: 'gray-40',
            cursor: 'not-allowed',
            borderColor: 'gray-40',
        }, '@media screen and (min-width: 30em)': {
            paddingTop: 'calc(1rem - 1px)',
            paddingBottom: 'calc(1rem - 1px)',
        } });
};
export var outlinedBaseButtonSx = __assign(__assign({}, COMMON_BUTTON_SX), { bg: 'transparent', borderStyle: 'solid', borderWidth: '1px', paddingTop: 'calc(1rem - 1px)', paddingBottom: 'calc(1rem - 1px)', '&:hover': {
        bg: 'transparent',
        cursor: 'pointer',
    }, '&:disabled': {
        backgroundColor: 'transparent',
        color: 'gray-40',
        borderColor: 'gray-40',
    }, '&:disabled:hover': {
        backgroundColor: 'transparent',
        color: 'gray-40',
        cursor: 'not-allowed',
        borderColor: 'gray-40',
    }, '@media screen and (min-width: 30em)': {
        paddingTop: 'calc(1rem - 1px)',
        paddingBottom: 'calc(1rem - 1px)',
    } });
export var getTextButtonSx = function (color) {
    return __assign(__assign({}, COMMON_BUTTON_SX), { color: color, bg: 'transparent', '&:hover': {
            cursor: 'pointer',
        }, '&:disabled': {
            backgroundColor: 'transparent',
            color: 'gray-40',
        }, '&:active': {
            color: 'primary-80',
            backgroundColor: 'transparent',
        }, '&:disabled:hover': {
            backgroundColor: 'transparent',
            color: 'gray-40',
            cursor: 'not-allowed',
        } });
};
export var textBaseButtonSx = __assign(__assign({}, COMMON_BUTTON_SX), { bg: 'transparent', paddingLeft: 0, paddingRight: 0, '&:hover': {
        bg: 'transparent',
        cursor: 'pointer',
    }, '&:disabled': {
        backgroundColor: 'transparent',
        color: 'gray-40',
    }, '&:disabled:hover': {
        backgroundColor: 'transparent',
        color: 'gray-40',
        cursor: 'not-allowed',
    } });
export var minimalButtonSx = {
    fontSize: 1,
    textTransform: 'none',
};
export var smallButtonSx = {
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 0,
    textTransform: 'none',
};
export var largeButtonSx = {
    paddingLeft: 5,
    paddingRight: 5,
    textAlign: 'center',
    fontSize: 2,
    paddingTop: 3,
    paddingBottom: 3,
    textTransform: 'none',
};
